query GetPaymentCycles($filter: PayCycleFilter) {
  payCycles(filter: $filter) {
    nodes {
      id
      businessUnit {
        name
      }
      businessUnitId
      description
      transactionTypeId
      businessUnitId
      paymentAccount {
        name
        bankAccountNumber
      }
      _isPaymentSelectable
      currency {
        isoCode
        name
        id
      }
      defaultPaymentDate
    }
  }
}
